<script lang="ts">
  import { Link } from "svelte-navigator";

  import type { SLAKRoute } from "../routes";

  export let route: SLAKRoute;

  switch (route.kind) {
    case "internal custom":
      throw new Error("Unsupported route type");
  }

  let hover: boolean = false;
  const toggle = () => (hover = !hover);
</script>

{#if route.kind !== "internal custom"}
  <!-- Little cheat to preload the 'hover' variant of the images -->
  <img
    style="display: none;"
    alt={route.navItem.alt}
    src={`assets/classic/nav_${route.navItem.imageName}_on.gif`}
  />

  {#if route.kind === "internal +navbar" || route.kind === "internal custom +navbar"}
    <Link to={route.path}
      ><span on:mouseenter={toggle} on:mouseleave={toggle}
        ><img
          alt={route.navItem.alt}
          src={hover
            ? `assets/classic/nav_${route.navItem.imageName}_on.gif`
            : `assets/classic/nav_${route.navItem.imageName}_off.gif`}
        /></span
      ></Link
    >{:else if route.kind === "external +navbar"}
    <a href={route.href}
      ><span on:mouseenter={toggle} on:mouseleave={toggle}
        ><img
          alt={route.navItem.alt}
          src={hover
            ? `assets/classic/nav_${route.navItem.imageName}_on.gif`
            : `assets/classic/nav_${route.navItem.imageName}_off.gif`}
        /></span
      ></a
    >{/if}
{/if}

<style></style>
